<script setup>
import Icon from 'dashboard/components-next/icon/Icon.vue';
import { messageStamp } from 'shared/helpers/timeHelper';

import { useI18n } from 'vue-i18n';
defineProps({
  inboxName: {
    type: String,
    default: '',
  },
  inboxIcon: {
    type: String,
    default: '',
  },
  scheduledAt: {
    type: Number,
    default: 0,
  },
});

const { t } = useI18n();
</script>

<template>
  <div class="flex flex-wrap items-center gap-2 w-full sm:flex-nowrap">
    <!-- Label visible on desktop -->
    <span
      class="hidden sm:inline flex-shrink-0 text-sm text-n-slate-11 whitespace-nowrap"
    >
      {{ t('CAMPAIGN.SMS.CARD.CAMPAIGN_DETAILS.SENT_FROM') }}
    </span>

    <div class="flex items-center gap-1.5 flex-shrink-0">
      <Icon :icon="inboxIcon" class="flex-shrink-0 text-n-slate-12 size-3" />
      <span class="text-sm font-medium text-n-slate-12">
        {{ inboxName }}
      </span>
    </div>

    <div class="flex items-center gap-1.5 w-full sm:w-auto">
      <!-- Label visible on desktop -->
      <span
        class="hidden sm:inline flex-shrink-0 text-sm text-n-slate-11 whitespace-nowrap"
      >
        {{ t('CAMPAIGN.SMS.CARD.CAMPAIGN_DETAILS.ON') }}
      </span>
      <span class="text-sm font-medium text-n-slate-12 truncate">
        {{ messageStamp(new Date(scheduledAt), 'LLL d, h:mm a') }}
      </span>
    </div>
  </div>
</template>
